<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.configuration') }} > {{ $t('sidebar.settings') }}
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <section class="col-12 no-padding">
        <div class="col-md-12 no-padding">
          <section-header :title="$t('message.document')"/>
          <div class="form-row">
            <div class="col-md-6">
              <div
                class="col-md-12 no-padding"
                style="height: 24px;">
                {{ $t('message.usedocumentlog') }}
              </div>
              <div
                class="form-group col-12 mb-0"
                style="padding: 0;">
                <div class="form-row no-padding no-margin">
                  <div
                    class="form-group col-6"
                    style="padding: 0;">
                    <div
                      class="box-input"
                      style="border-radius: 0;">
                      <vs-checkbox
                        v-model="settings.log_topic.is_active"
                        color="#A3CA76"
                        style="float: left;position: relative;top: 1px;left: -5px;"
                      >
                        <span v-if="!settings.log_topic.is_active">{{ $t('message.disabled') }}</span>
                        <span v-else>{{ $t('message.enabled') }}</span>
                      </vs-checkbox>
                    </div>
                  </div>
                  <div
                    class="form-group col-6"
                    style="padding-left: 0;padding-right: 0;"
                  >
                    <div
                      class="box-input active"
                      style="
                          border-radius: 0px .25rem .25rem 0;
                          border-left: 0;
                          padding-right: 3px;
                          display: flex;
                          justify-content: space-between;
                          align-items: center;
                        "
                    >
                      <span/>
                      <button
                        class="btn btn-light"
                        style="height: 28px;font-size: 11px;box-shadow: none;"
                        @click="handleOpenLogTipicMasterData"
                      >
                        {{ $t('message.managemasterdata', { number: settings.log_topic.options.length }) }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6">
              <div
                class="col-md-12 no-padding"
                style="height: 24px;">
                {{ $t('message.usedocumentattachfile') }}
              </div>
              <div
                class="form-group col-12 mb-0"
                style="padding: 0;">
                <div class="form-row no-padding no-margin">
                  <div
                    class="form-group col-12"
                    style="padding: 0;">
                    <div class="box-input">
                      <vs-checkbox
                        v-model="settings.attach_file.is_active"
                        color="#A3CA76"
                        style="float: left;position: relative;top: 1px;left: -5px;"
                      >
                        <span v-if="!settings.attach_file.is_active">{{ $t('message.disabled') }}</span>
                        <span v-else>{{ $t('message.enabled') }}</span>
                      </vs-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="col-12 no-padding">
        <div class="col-md-12 no-padding">
          <section-header :title="$t('apps.sales.message.sotemplate')"/>
          <div class="form-row">
            <div class="col-md-6">
              <div class="row">
                <div class="col-12">
                  <div
                    class="col-md-12 no-padding"
                    style="height: 24px;">
                    {{ $t('message.fixedsignaturebottom') }}
                  </div>
                  <div
                    class="form-group col-12 m-0"
                    style="padding: 0;"
                  >
                    <div class="form-row no-padding no-margin">
                      <div
                        class="form-group col-12"
                        style="padding: 0;">
                        <div
                          class="box-input"
                          style="border-radius: 0;">
                          <vs-checkbox
                            v-model="settings.doc_template.is_fixed_signature_bottom"
                            color="#A3CA76"
                            style="float: left;position: relative;top: 1px;left: -5px;"
                          >
                            <span v-if="settings.doc_template.is_fixed_signature_bottom">{{ $t('message.yes') }}</span>
                            <span v-else>{{ $t('message.no') }}</span>
                          </vs-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 mb-2">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label>{{ $t('apps.pos.message.fontsize') }}</label>
                      <select
                        v-model="settings.doc_template.font_size"
                        class="custom-select form-control"
                      >
                        <option :value="50">50%</option>
                        <option :value="60">60%</option>
                        <option :value="70">70%</option>
                        <option :value="80">80%</option>
                        <option :value="90">90%</option>
                        <option :value="100">100%</option>
                        <option :value="110">110%</option>
                        <option :value="120">120%</option>
                        <option :value="130">130%</option>
                        <option :value="140">140%</option>
                        <option :value="150">150%</option>
                        <option :value="160">160%</option>
                        <option :value="170">170%</option>
                        <option :value="180">180%</option>
                        <option :value="190">190%</option>
                        <option :value="200">200%</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 wrapper-doc-demo">
              <div class="wrapper-doc-demo-bg">
                <div class="wrapper-doc-demo-outer">
                  <div class="wrapper-doc-demo-inner">
                    <printsale-view
                      :sale="docInfo"
                      :fontSize="settings.doc_template.font_size"
                      :isFixedSignatureBottom="settings.doc_template.is_fixed_signature_bottom"
                      class="print-template"
                    />
                  </div>
                </div>
                <div class="mt-4 text-center">
                  <button
                    class="btn btn-ligth"
                    style="background-color: #ccc;"
                    @click="onClickPrint">
                    <span>
                      {{ $t('message.testprint') }}
                    </span>
                    <i class="fas fa-print"/>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <BaseFormAction
        :textSubmit="$t('button.save')"
        :isSubmitted="isSubmitted"
        @onSubmit="handleSubmit"
      />

      <BaseConfirmDiscardModal
        :show="confirmDiscardModal.show"
        @onCancel="handleDiscardCancleModal"
        @onConfirm="handleDiscardConfirmModal"
      />

      <BaseModalCustomMasterData
        :list="settings.log_topic.options"
        :id="MODAL_LOG_TOPIC_MASTER_DATA"
        :headerText="$t('message.managetopicoptions')"
        :showCheckboxDefault="false"
        @onClose="handleCloseLogTopicMasterData"
        @onSubmit="handleSubmitLogTopicMasterData"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'

import sidebarModule from './../../sidebarModule'
import discardFormMixin from '@/mixins/discardForm'
import printsaleView from '@/components/apps/sales/so/include/PrintSale.vue'

export default {
  mixins: [discardFormMixin],

  components: {
    printsaleView,
  },

  data () {
    return {
      MODAL_LOG_TOPIC_MASTER_DATA: 'MODAL_LOG_TOPIC_MASTER_DATA',
      loading: false,
      isSubmitted: false,
      settings: {},
      original_settings: {},
      docInfo: {
        'so_code': `SO-${this.moment().format('YYYY')}0001`,
        'note': null,
        'scheduled_at': this.moment().toDate().toString(),
        'credit': {
          'type': 'cash',
          'days': 0,
        },
        'orders': [
          {
            'item': this.$t('apps.pos.message.demoproductname'),
            'description': this.$t('apps.pos.message.demoproductname'),
            'price': 999,
            'quantity': 1,
            'discounts': [],
            'taxes': [],
          },
        ],
        'customer': {
          'customer_name': this.$t('apps.pos.message.democustomername'),
          'contacts': [],
        },
        'reference': {
          'goodsissues': [],
          'invoices': [],
        },
      },
    }
  },

  computed: {
    ...mapGetters({
      getSaleSetting: 'getSaleSetting',
    }),
    form () {
      return {
        settings: this.settings,
      }
    },
  },

  async created () {
    this.settings = _.cloneDeep(this.getSaleSetting)
    this.original_settings = _.cloneDeep(this.getSaleSetting)
    this.showFinish(this.$Progress)
  },

  beforeMount () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.sales.title'),
      current: {
        app_name: 'sales',
        app_id: 5,
        module_id: 2,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 2,
      submenuAtIdx: 0,
    })
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
  },

  methods: {
    ...mapActions([
      'updateSettingsSale',
    ]),
    onClickPrint () {
      $('.print-template').printThis({
        importStyle: true, // import style tag
      })
    },
    async handleSubmit() {
      this.isSubmitted = true
      const response = await this.updateSettingsSale(this.settings)
      if (response.success) {
        this.notify(this.$vs, {
          text: this.$t('message.saved'),
          color: 'success',
          icon: 'cloud',
        })
        this.showFinish(this.$Progress)
        this.isSubmitted = false
      }
    },
    handleOpenLogTipicMasterData() {
      $(`#${this.MODAL_LOG_TOPIC_MASTER_DATA}`).modal('show')
    },
    handleCloseLogTopicMasterData() {
      this.settings.log_topic.options = _.cloneDeep(this.original_settings.log_topic.options)
      $(`#${this.MODAL_LOG_TOPIC_MASTER_DATA}`).modal('hide')
    },
    async handleSubmitLogTopicMasterData(payload) {
      this.settings.log_topic.options = _.cloneDeep(payload)
      this.original_settings.log_topic.options = _.cloneDeep(payload)
      $(`#${this.MODAL_LOG_TOPIC_MASTER_DATA}`).modal('hide')
    },
  },
}
</script>

<style scoped>
.box-input {
  position: relative;
  padding-left: 7px;
  height: 35px;
  background: #fff;
  border: 1px solid #ced4da;
  color: #495057;
  line-height: 35px;
  border-radius: .25rem;
  display: inline-block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.box-input.active {
  background: #e9ecef;
  border-radius: .25rem;
}

.wrapper-doc-demo {
  position: relative;
  padding: 0 0 0 40px;
  margin-top: 25px;
}

.wrapper-doc-demo-bg {
  background: #efefef;
  padding: 20px;
}

.wrapper-doc-demo-outer {
  width: 472px;
  height: 636px;
  position: relative;
  left: calc(50% - 236px);
  margin-top: -30px;
}

.wrapper-doc-demo-inner {
  transform: scale(.5) translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/apps/sales/configuration/Setting.vue